import { useCallback, useEffect, useState } from "react";
import {
  fetchHotelCxlDropRiskAlerts,
  peekHotelCxlDropRiskAlertsCache,
} from "./fetchHotelCxlDropRiskAlerts";
import { summarizeHotelCxlDropRiskAlerts } from "../../utils/orders/resolveHotelCxlDropRisk";

const EMPTY = {
  alerts: [],
  summary: summarizeHotelCxlDropRiskAlerts([]),
  viewerIsOps: false,
  error: null,
};

export function useHotelCxlDropRiskAlerts() {
  const cached = peekHotelCxlDropRiskAlertsCache();
  const [state, setState] = useState(cached || EMPTY);
  const [loading, setLoading] = useState(!cached);

  const reload = useCallback(async (force = false) => {
    if (!peekHotelCxlDropRiskAlertsCache()) setLoading(true);
    try {
      const next = await fetchHotelCxlDropRiskAlerts({ force });
      setState(next);
    } catch {
      setState((prev) => prev || EMPTY);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const next = await fetchHotelCxlDropRiskAlerts();
        if (!cancelled) setState(next);
      } catch {
        /* keep previous */
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    const interval = setInterval(() => {
      fetchHotelCxlDropRiskAlerts({ force: true })
        .then((next) => {
          if (!cancelled) setState(next);
        })
        .catch(() => {});
    }, 5 * 60 * 1000);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, []);

  return {
    alerts: state.alerts,
    summary: state.summary,
    viewerIsOps: state.viewerIsOps,
    error: state.error,
    loading,
    reload,
  };
}
